import React from "react";
import { HelpDrawerWrapper } from "../../../components";
import { useTranslate } from "../../../helpers";

const HouseholdDiscountHelpDrawer = () => {
  const t = useTranslate();
  return (
    <HelpDrawerWrapper
      toggleText={t("medigap.household_discounts.question")}
      drawerTitle={t("medigap.household_discounts.question")}
      toggleClassName="ds-u-text-align--left"
    >
      <p>{t("medigap.household_discount.help_drawer_content")}</p>
    </HelpDrawerWrapper>
  );
};

export default HouseholdDiscountHelpDrawer;
